import React from 'react';

interface SettingIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const SettingIcon: React.FC<SettingIconProps> = ({
  width = 16,
  height = 17,
  color = 'currentColor',
  className,
  style,
  title,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      role="img"
      aria-hidden={!title}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <path
        d="M6.04968 0.796875C6.14343 0.334375 6.55281 0 7.02781 0H8.89656C9.37156 0 9.78093 0.334375 9.87468 0.796875L10.3278 2.98438C10.7684 3.17188 11.1809 3.4125 11.5559 3.69688L13.6747 2.99375C14.1247 2.84375 14.6184 3.03125 14.8559 3.44375L15.7903 5.0625C16.0278 5.475 15.9434 5.99375 15.5872 6.30937L13.9216 7.79063C13.9497 8.02188 13.9622 8.25937 13.9622 8.5C13.9622 8.74063 13.9466 8.97813 13.9216 9.20938L15.5903 10.6938C15.9466 11.0094 16.0278 11.5312 15.7934 11.9406L14.8591 13.5594C14.6216 13.9688 14.1278 14.1594 13.6778 14.0094L11.5591 13.3062C11.1809 13.5906 10.7684 13.8281 10.3309 14.0188L9.88093 16.2031C9.78406 16.6688 9.37468 17 8.90281 17H7.03406C6.55906 17 6.14968 16.6656 6.05593 16.2031L5.60593 14.0188C5.16531 13.8313 4.75593 13.5906 4.37781 13.3062L2.24968 14.0094C1.79968 14.1594 1.30593 13.9719 1.06843 13.5594L0.134057 11.9406C-0.103443 11.5281 -0.0190676 11.0094 0.337182 10.6938L2.00593 9.20938C1.97781 8.97813 1.96531 8.74063 1.96531 8.5C1.96531 8.25937 1.98093 8.02188 2.00593 7.79063L0.337182 6.30625C-0.0190676 5.99062 -0.100318 5.46875 0.134057 5.05937L1.06843 3.44062C1.30593 3.02813 1.79968 2.84062 2.24968 2.99062L4.36843 3.69375C4.74656 3.40937 5.15906 3.17188 5.59656 2.98125L6.04968 0.796875ZM7.96218 11C8.29049 10.9988 8.61533 10.9329 8.91818 10.8061C9.22102 10.6793 9.49593 10.4942 9.7272 10.2611C9.95848 10.0281 10.1416 9.75183 10.2661 9.44805C10.3906 9.14426 10.454 8.81893 10.4528 8.49063C10.4516 8.16232 10.3857 7.83747 10.2589 7.53463C10.1321 7.23179 9.94696 6.95688 9.71395 6.7256C9.48093 6.49433 9.20464 6.31121 8.90086 6.18671C8.59707 6.06221 8.27174 5.99877 7.94343 6C7.61513 6.00123 7.29028 6.06711 6.98744 6.19389C6.68459 6.32066 6.40969 6.50585 6.17841 6.73886C5.94714 6.97188 5.76402 7.24817 5.63952 7.55195C5.51502 7.85574 5.45158 8.18107 5.45281 8.50937C5.45404 8.83768 5.51992 9.16253 5.6467 9.46537C5.77347 9.76821 5.95865 10.0431 6.19167 10.2744C6.42469 10.5057 6.70097 10.6888 7.00476 10.8133C7.30855 10.9378 7.63388 11.0012 7.96218 11Z"
        fill={color}
      />
    </svg>
  );
};

export default SettingIcon;
